import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { fetchUserWithProfile } from '../utils/auth';
import './UserProfile.css';

const UserProfile = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadUserProfile = async () => {
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    console.dir(userFromLocalStorage)
    let userWithProfile = await fetchUserWithProfile(userFromLocalStorage.pk)
    setLoading(false);
    setUserProfile(userWithProfile);
    console.dir("loadUserProfile completed")
    console.dir(userWithProfile)
  }

  useEffect(() => {
    loadUserProfile();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handlePhotoChange = (e) => {
    const { name, files } = e.target;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: URL.createObjectURL(files[0])
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const pk = userFromLocalStorage.pk
    
    try {
      await axiosInstance.put(`users/${pk}/`, userProfile);
      alert('Profile updated successfully');
    } catch (error) {
      setError('Error updating profile');
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="profile-parent-container">
      <div className="profile-container">
        <h1>Edit your Profile</h1>
        <form onSubmit={handleSubmit} className="profile-form">
        <label>
            <span>First Name:</span>
            <input
              type="text"
              name="first_name"
              value={userProfile.first_name}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Last Name:</span>
            <input
              type="text"
              name="last_name"
              value={userProfile.last_name}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Title:</span>
            <input
              type="text"
              name="title"
              value={userProfile.title}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Work Phone:</span>
            <input
              type="text"
              name="workPhone"
              value={userProfile.workPhone}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Mobile Phone:</span>
            <input
              type="text"
              name="mobilePhone"
              value={userProfile.mobilePhone}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Email:</span>
            <input
              type="email"
              name="email"
              value={userProfile.email}
              onChange={handleInputChange}
              disabled
            />
          </label>
          <label>
            <span>Default Edit Form View:</span>
            <input
              type="text"
              name="defaultView"
              value={userProfile.defaultView}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Notifications:</span>
            <input
              type="text"
              name="notifications"
              value={userProfile.notifications}
              onChange={handleInputChange}
            />
          </label>
          <label>
            <span>Dashboard Preferences:</span>
            <input
              type="text"
              name="dashboardPreferences"
              value={userProfile.dashboardPreferences}
              onChange={handleInputChange}
            />
          </label>
          <div className="profile-actions">
            <button type="button" onClick={() => window.location.reload()}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserProfile;
